
/// <amd-module name="Repos/PullRequestCommon/PullRequestDescriptionService" />
import { translateDisplayNamesToStorageKeys } from "Mention/Common/DisplayNameStorageKeyTranslationService";
import { useStorageKeysInMentions } from "Mention/Common/Util";
import { calculateTrueContentLength } from "Repos/PullRequest/Attachments/Attachment";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IPullRequestDescriptionService extends IVssService {
    /**
     * Transforms value to actual string that will be saved as description and validates it's length.
     */
    isDescriptionActualLengthValid(value: string): boolean;
}

export const maxDescriptionLength = 4000;

class PullRequestDescriptionService extends VssService implements IPullRequestDescriptionService {
    isDescriptionActualLengthValid(value: string): boolean {
        const description = useStorageKeysInMentions(this.pageContext)
            ? translateDisplayNamesToStorageKeys(this.pageContext, value)
            : value;
        return calculateTrueContentLength(this.pageContext, description) > maxDescriptionLength;
    }
}

const serviceName = "IPullRequestDescriptionService";

export function getPullRequestDescriptionService(pageContext: IVssPageContext): IPullRequestDescriptionService {
    return pageContext.getService<IPullRequestDescriptionService>(serviceName);
}

Services.add(serviceName, { serviceFactory: PullRequestDescriptionService });
